import { FC } from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import styles from './CustomCheckbox.module.scss';

type CustomCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  customClass?: string;
  activeColor?: string;
};

const CustomCheckbox: FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
  size = 'medium',
  customClass,
  activeColor,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case 'small':
        return styles.small;
      case 'large':
        return styles.large;
      default:
        return styles.medium;
    }
  };

  return (
    <Box
      className={`${styles.customCheckbox} ${getSizeClass()} ${disabled ? styles.disabled : ''} ${customClass || ''}`}
      onClick={handleClick}
    >
      {checked ? (
        <CheckCircleIcon
          className={styles.checkboxActive}
          sx={activeColor ? { color: `${activeColor} !important` } : undefined}
        />
      ) : (
        <Box className={styles.checkboxInactive} />
      )}
    </Box>
  );
};

export default CustomCheckbox;
